module.exports = __webpack_public_path__ + "img/0Q3B8639-42_H_Foamcore_MockedUp.82fad272.jpg";